<template>
  <div
    class="flex size-full flex-col items-stretch overflow-hidden"
  >
    <div
      class="flex shrink-0 border-b bg-gradient-to-r from-primary to-secondary py-2 text-primary-fg"
    >
      <div
        class="mx-auto flex w-full max-w-lg items-center px-2 sm:px-6 lg:px-8"
      >
        <IconBeepaidIconWhite class="my-1 size-10" />
        <h1
          class="mx-2 line-clamp-1 grow text-center text-2xl font-medium leading-relaxed"
        >
          {{
            route.name === "home"
              ? currentTenant?.name
              : pageTitle
          }}
        </h1>
        <div class="w-10" />
      </div>
    </div>
    <main
      class="mx-auto flex size-full flex-col overflow-hidden sm:max-w-lg sm:p-4"
    >
      <BaseCard
        class="min-h-full overflow-y-auto sm:min-h-0"
      >
        <InviteAcceptForm :invite-token="token" />
      </BaseCard>
    </main>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  token: string
}>()

const { currentTenant } = useCurrentTenant()
const { pageTitle } = usePageTitle()
const route = useRoute()
</script>
